<template>
  <Modal
    :visible="true"
    :close-on-escape="false"
    :modal="true"
    :closable="false"
    :show-header="false"
  >
    <div :class="$style.wrapper">
      <h2>Whoops!</h2>
      <p v-html="displayedErrorMessage"></p>
      <p>
        Please <router-link to="/logout">Logout</router-link> in order to
        reattempt login or you will be redirected shortly.
      </p>
      <p class="bold">If this issue persists please contact support at:</p>
      <div>
        {{ $t('components.popupApiError.email') }}
        <a :href="contactSupportMethods.email.href">{{
          contactSupportMethods.email.display
        }}</a>
      </div>
      <div>
        {{ $t('components.popupApiError.phone') }}
        <a :href="contactSupportMethods.phone.href">{{
          contactSupportMethods.phone.display
        }}</a>
      </div>
    </div>
  </Modal>
</template>

<script>
import * as Sentry from '@sentry/vue';
import Modal from '@/components/shared/Dialog.vue';
import { ContactSupportMethods } from '@/data/contact-support';
import { RouteNames } from '@/data/routes';
import { auth0, isTokenExpiredError } from '@/utils/auth0';
import { formatHrefLink } from '@/utils/strings';
import { faro } from '@grafana/faro-web-sdk';
import { unref } from 'vue';

export default {
  components: {
    Modal,
  },
  props: {
    errorMessage: { type: String },
  },
  data() {
    return { contactSupportMethods: ContactSupportMethods };
  },
  mounted() {
    const auth0Error = unref(auth0.error);

    if (auth0Error instanceof Error) {
      faro.api.pushError(auth0Error, {
        type: 'Auth0 Error',
      });
    }

    setTimeout(() => {
      this.$router.push({ name: RouteNames.AUTH.LOGOUT });
    }, 10000);
  },
  computed: {
    displayedErrorMessage() {
      if (this.errorMessage) {
        // Auth0 does not provide a user-friendly error message or code for this error,
        // so we handle it manually.
        switch (this.errorMessage.toLowerCase()) {
          case 'invitation not found or already used':
          case 'parameter organization is not allowed for this client':
            return 'This invitation link is no longer valid. Please request a new invitation link from your admin.';
          default:
            // Display hyperlinks in Auth0 error messages
            const auth0Error = unref(auth0.error);
            if (auth0Error?.message) {
              return formatHrefLink(auth0Error.message);
            }

            return this.errorMessage;
        }
      }

      Sentry.captureException(new Error('Auth0 Error'), {
        extra: { originalError: auth0.error },
      });

      if (isTokenExpiredError(auth0.error)) {
        return 'We encountered an issue, please ensure your system time is set correctly.';
      }

      return 'An unexpected error occurred.';
    },
  },
};
</script>

<style lang="less" module>
.wrapper {
  padding: 20px 20px 0;
  color: #000;
  h2 {
    font-size: 1.75rem;
    font-weight: 500;
  }
}
</style>
